import { useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import userImg from "../../assets/images/user.svg";
import Input, { TextArea } from "../../components/CommonComponents/Input/Input";
import { ErrorToast, SuccessToast } from "../../components/toastMessage";
import { BASE_URL } from "../../constants/Constants";
import { useSetUser, useUser } from "../../contexts/UserContext";
import { useUserRegistration } from "../../contexts/UserRegistrationContext";
import { useUpdateProfile } from "../../hooks/user.hooks";
import { downloadResource } from "../../utils/common";
import ViewDocument from "../LevelTwo/ViewDocument";
import { GoogleReCaptcha, GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { cookieUtils } from "../../utils/cookieUtils";
import { _axios } from "../../utils/axios";

export function UserProfile() {
  // const [isAdminMode, setIsAdminMode] = useState<boolean>(localStorage.getItem('isAdminMode') == 'true')
  const [isAdminMode, setIsAdminMode] = useState<boolean>(() => {
    const adminMode = cookieUtils.getSecureCookie('isAdminMode');
    return adminMode === 'true';
  });
  const user = useUser();
  const userRegistration = useUserRegistration();
  const setUser = useSetUser();
  const navigate = useNavigate();
  const qc = useQueryClient();
  const updateProfile = useUpdateProfile();
  const [token, setToken] = useState('');
  const [document, setDocument] = useState<{
    name: string;
    url: string;
  } | null>(null);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isMobileOtpSent, setIsMobileOtpSent] = useState(false);
  const shouldHideAddress = () => {
    const hideAddressRoles = ["Level 1", "Level 2", "Level 3", "System Admin"];
    return user && hideAddressRoles.includes(user.role);
  };
  const { formState, register, handleSubmit, getValues, control } = useForm({
    defaultValues: {
      name: user?.name || "",
      mobile: user?.mobile || "",
      email: user?.email || "",
      office_address: shouldHideAddress() ? undefined : userRegistration?.office_address || "",
      document_type: userRegistration?.document_type || "",
      emailOTP: "",
      mobileOTP: "",
    },
  });

  const handleVerify = (token: React.SetStateAction<string>) => {
    setToken(token);
    console.log('recaptcha V3', token);
  };

  const watchedMobile = useWatch({
    control: control,
    name: "mobile",
    defaultValue: user?.mobile,
  });
  const watchedEmail = useWatch({
    control: control,
    name: "email",
    defaultValue: user?.email,
  });

  const sendSMSEmail = (data: any, isEmail: boolean) => {
    _axios
      .post(`${BASE_URL}/api/email-verification/sent`, {
        user_id: user?.user_id,
        name: formState?.defaultValues?.name,
        email: isEmail ? data?.email : undefined,
        mobile_number: isEmail ? undefined : data?.mobile,
        "token": token

      })
      .then(function (response) {
        console.log("response", response);
        SuccessToast(
          `OTP sent successfully on ${isEmail ? "email" : "via SMS"}`
        );
        isEmail ? setIsOtpSent(true) : setIsMobileOtpSent(true);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        // ErrorToast(response.data.message);

      });
  };

  if (!user) return null;

  const clearAllCookies = () => {
    // Clear all known cookies
    cookieUtils.removeSecureCookie('userDetails');
    cookieUtils.removeSecureCookie('token');
    cookieUtils.removeSecureCookie('subRole');
    // Add any other cookies that need to be cleared
  };

  const onLogout = () => {
    qc.clear();
    setUser(null);
    localStorage.clear();
    clearAllCookies();
    navigate("/onboarding/login");
  };

  const sentOtpforEmail = () => {
    sendSMSEmail(getValues(), true);
    return false;
  };

  const sentOtpforMobile = () => {
    sendSMSEmail(getValues(), false);
    return false;
  };

  const onSubmit = (data: any) => {
    if (isOtpSent && isMobileOtpSent) {
      _axios
        .post(`${BASE_URL}/api/email-verification/verify`, {
          user_id: user?.user_id,
          name: data?.name,
          email: data?.email,
          mobile_number: data?.mobile,
          otp: isOtpSent ? data.emailOTP : undefined,
          "token": token

        })
        .then(async function (response) {
          console.log("response", response);
          if (response?.data?.status == "verified") {
            _axios
              .post(`${BASE_URL}/api/email-verification/sms-verify`, {
                user_id: user?.user_id,
                name: data?.name,
                email: data?.email,
                mobile_number: data?.mobile,
                otp: isMobileOtpSent ? data.mobileOTP : undefined,
              })
              .then(async function (response) {
                console.log("response", response);
                if (response?.data?.status == "verified") {
                  updateProfile.mutate(data);
                  setIsOtpSent(false);
                  setIsMobileOtpSent(false);
                } else ErrorToast("Please Verify your OTP for email change");
              });
          } else ErrorToast("Please Verify your OTP for email change");
        });
    } else if (isOtpSent) {
      _axios
        .post(`${BASE_URL}/api/email-verification/verify`, {
          user_id: user?.user_id,
          name: data?.name,
          email: data?.email,
          mobile_number: data?.mobile,
          otp: isOtpSent ? data.emailOTP : undefined,
          "token": token

        })
        .then(async function (response) {
          console.log("response", response);
          if (response?.data?.status == "verified") {
            updateProfile.mutate(data);
            setIsOtpSent(false);
            setIsMobileOtpSent(false);
          } else ErrorToast("Please Verify your OTP for email change");
        });
    } else {
      _axios
        .post(`${BASE_URL}/api/email-verification/sms-verify`, {
          user_id: user?.user_id,
          name: data?.name,
          email: data?.email,
          mobile_number: data?.mobile,
          otp: isMobileOtpSent ? data.mobileOTP : undefined,
        })
        .then(async function (response) {
          console.log("response", response);
          if (response?.data?.status == "verified") {
            updateProfile.mutate(data);
            setIsOtpSent(false);
            setIsMobileOtpSent(false);
          } else ErrorToast("Please Verify your OTP for email change");
        });
    }
  };


  // console.log("user reg", userRegistration?.regestration_status);
  const getBackRoute = () => {
  
    // The existing logic for different roles
    if (user?.role?.toLowerCase() === "system admin") {
      return isAdminMode ? "/dashboard" : "/level-three-applications";
    }

    if (userRegistration?.regestration_status === 0) {
      return "/user-account-not-verified";
    } else if (userRegistration?.regestration_status === 1) {
      return "/user-applications";
    }
  
    switch (user?.role?.toLowerCase()) {
      case "level 1":
        return "/level-1-applications";
      case "level 2":
        return "/level-2-applications";
      case "level 3":
        return "/level-three-applications";
      default:
        return "/user-applications";
    }
  };

  return (
    <GoogleReCaptchaProvider reCaptchaKey="6LdRltoqAAAAAKddCuFxu0SGioWr8tMtYSESl_ol">
    <div className="grid grid-cols-3 p-8 gap-8">
      <div className="relative col-span-3 md:col-span-1 rounded-2xl shadow-md bg-white text-center px-8 pb-8 pt-[92px] mt-24">
        <img
          src={userImg}
          className="absolute top-0 left-[50%] h-[120px] -translate-x-[50%] -translate-y-[50%]"
          alt="profile-pic"
        />
        <h5 className="text-xl text-grey-600 mb-8 font-bold">{user?.name}</h5>
        <h5 className="text-xl capitalize text-gray-500 mb-8">
          {user.role === "user" ? userRegistration?.user_type : user.role}
        </h5>
        <button
          type="button"
          onClick={onLogout}
          className="block w-full bg-primary px-6 py-3 rounded font-bold uppercase "
        >
          Logout
        </button>
      </div>

      <div className="col-span-3 md:col-span-2 h-full flex flex-col space-y-8 mt-12">
        <h5 className="text-2xl font-bold col-span-2">Profile</h5>
        <form
  noValidate
  id="user-profile"
  className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-8"
  onSubmit={handleSubmit((data) => {
    const submissionData = shouldHideAddress() ? { ...data, office_address: undefined } : data;
    if (getValues().email !== formState.defaultValues?.email ||
        getValues().mobile !== formState.defaultValues?.mobile) {
      onSubmit(submissionData);
    } else {
      updateProfile.mutate(submissionData);
    }
  })}
>
        {/* <form
          noValidate
          id="user-profile"
          className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-8"
          onSubmit={handleSubmit((data) =>
            getValues().email !== formState.defaultValues?.email ||
            getValues().mobile !== formState.defaultValues?.mobile
              ? onSubmit(data)
              : updateProfile.mutate(data)
          )}
        > */}
          <Input
            label="Name"
            required
            placeholder={"Enter Name"}
            error={!!formState?.errors?.name}
            helperText={formState?.errors?.name?.message?.toString?.()}
            {...register("name", { required: "* Required" })}
          />
          <div></div>
          {!!userRegistration?.gov_id_document && (
          <TextArea
            label="Address"
            required
            placeholder={"Enter Address"}
            error={!!formState?.errors?.office_address}
            containerClass="col-span-1 lg:col-span-2"
            helperText={formState?.errors?.office_address?.message?.toString?.()}
            {...register("office_address", { required: "* Required" })}
          />
        )}
          {!!userRegistration?.gov_id_document && (
            <Input
              label="Document Type"
              required
              disabled
              placeholder={"Document Type"}
              error={!!formState?.errors?.document_type}
              helperText={formState?.errors?.document_type?.message?.toString?.()}
              {...register("document_type", { required: "* Required" })}
            />
          )}
          {!!userRegistration?.gov_id_document && (
            <div className="flex gap-4 items-center mt-6 lg:mt-0">
              <iframe
                width={250}
                height={100}
                src={userRegistration?.gov_id_document}
                className="hidden lg:block"
              />
              <button
                type="button"
                className="text-lg"
                onClick={() =>
                  setDocument({
                    url: String(userRegistration?.gov_id_document),
                    name: String(userRegistration?.document_type ?? "Document"),
                  })
                }
              >
                <i className="m-0 fa fa-eye"></i>
              </button>
              <button
                type="button"
                onClick={() =>
                  downloadResource(String(userRegistration?.gov_id_document))
                }
                className="text-lg"
              >
                <i className="m-0 fa fa-download"></i>
              </button>
            </div>
          )}
          <Input
            label="Email ID"
            required
            // disabled
            placeholder={"Enter Email ID"}
            error={!!formState?.errors?.email}
            isOtpVerification={
              !!(
                !formState?.errors?.email &&
                watchedEmail?.trim() &&
                watchedEmail.trim() !== user?.email
              )
            }
            onVerify={sentOtpforEmail}
            helperText={formState?.errors?.email?.message?.toString?.()}
            {...register("email", {
              required: "* Required",
              validate: (v) =>
                /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(v)
                  ? true
                  : "Invalid Email",
            })}
          />
          <Input
            required
            label="Mobile No"
            placeholder={"Enter Mobile No"}
            isOtpVerification={
              !!(
                !formState?.errors?.mobile &&
                watchedMobile?.trim() &&
                watchedMobile.trim() !== user?.mobile
              )
            }
            onVerify={sentOtpforMobile}
            error={!!formState?.errors?.mobile}
            helperText={formState?.errors?.mobile?.message?.toString?.()}
            {...register("mobile", {
              required: "* Required",
              validate: (v) =>
                /^[6-9]\d{9}$/.test(v) ? true : "Invalid Mobile No",
            })}
          />
          {isOtpSent && (
            <div>
              <Input
                label=""
                required
                placeholder={"Enter OTP"}
                {...register("emailOTP")}
              />
              <p className="pt-2">
                Enter email OTP here{" "}
                <span
                  onClick={sentOtpforEmail}
                  className="cursor-pointer text-amber-400 font-bold"
                >
                  Resend
                </span>
              </p>
            </div>
          )}
          {isMobileOtpSent && (
            <>
              {!isOtpSent && <div></div>}
              <div>
                <Input
                  label=""
                  required
                  placeholder={"Enter OTP"}
                  {...register("mobileOTP")}
                />
                <p className="pt-2">
                  Enter SMS OTP here{" "}
                  <span
                    onClick={sentOtpforMobile}
                    className="cursor-pointer text-amber-400 font-bold"
                  >
                    Resend
                  </span>
                </p>
              </div>
            </>
          )}
        </form>
        <div className="col-span-2 flex justify-center items-center">
        <button
  type="submit"
  form="user-profile"
  onClick={() => navigate(getBackRoute())}
  className="bg-black px-6 py-2 rounded-full font-bold text-white mt-10 me-5"
>
  Back
</button>
          <button
            type="submit"
            form="user-profile"
            disabled={updateProfile.isPending}
            className="bg-primary px-6 py-2 rounded-full font-bold text-white mt-10"
          >
            {updateProfile.isPending ? "Saving" : "Save"}
          </button>
        </div>
      </div>
      {!!document && <ViewDocument {...document} onClose={() => setDocument(null)} />}
    </div>
    <GoogleReCaptcha onVerify={handleVerify} />
    </GoogleReCaptchaProvider>
  );
}